import React from 'react';
export var ConditionalWrapper = function (_a) {
    var wrap = _a.wrap, elseWrap = _a.elseWrap, condition = _a.condition, children = _a.children;
    return (React.createElement(React.Fragment, null, condition && wrap
        ? wrap(children)
        : elseWrap
            ? elseWrap(children)
            : children));
};
ConditionalWrapper.displayName = 'ConditionalWrapper';
export default ConditionalWrapper;
//# sourceMappingURL=ConditionalWrapper.js.map